<template>
    <CompassTooltip :content="$filters.capitalize(name)" placement="top" :arrow="false">
        <span :class="classes" @click="handleClick">
            {{ $filters.capitalize(name) }}
        </span>
    </CompassTooltip>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true,
        },
        link: {
            type: String,
            default: null,
        },
    },
    computed: {
        classes() {
            return [
                'object-block__header-name',
                'typographies-paragraph-medium-semibold',
                { 'object-block__header-name--link': !!this.link },
            ];
        },
    },
    methods: {
        handleClick() {
            if (this.link) {
                window.open(this.link, '_blank');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.object-block__header-name {
    &--link {
        cursor: pointer;
        &:hover {
            text-decoration: underline;
        }
    }
}
</style>
